import { render, staticRenderFns } from "./HeaderTotal.vue?vue&type=template&id=6ce09946&scoped=true"
import script from "./HeaderTotal.vue?vue&type=script&lang=js"
export * from "./HeaderTotal.vue?vue&type=script&lang=js"
import style0 from "./HeaderTotal.vue?vue&type=style&index=0&id=6ce09946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce09946",
  null
  
)

export default component.exports